import React, { useState, useEffect } from "react";

const flagCodes = {
  Philippines: "ph",
  Vietnam: "vn",
};

const FlagIcon = ({ country }) => {
  const code = flagCodes[country];
  if (!code) {
    return (
      <span aria-hidden="true" style={{ fontSize: "1rem" }}>
        🏳️
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/w20/${code}.png`}
      alt=""
      aria-label={`${country} flag`}
      style={{
        width: "20px",
        height: "14px",
        objectFit: "cover",
        borderRadius: "2px",
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
      }}
    />
  );
};

const testimonials = [
  {
    name: "Erwin Concepcion",
    role: "IT, COOL Staff",
    country: "Philippines",
    photo: "	https://fms.techtreeglobal.com/assets/uploads/1761492000_Erwin.jpg",
    message:
      "COOL helped me connect with amazing mentors and learners across Asia. The platform truly inspires growth and collaboration!",
  },
  {
    name: "Nghĩa",
    role: "ReallyScholar Student",
    country: "Vietnam",
    photo: "	https://fms.techtreeglobal.com/assets/uploads/1769579700_ngaia.jpeg",
    message:
      "I've started month ago and I could see that the precious value in the knowlegde of the courrlse in ReallyScholar, about the support team what I could say that they so brilliant in supporting me when I have any question",
  },
  {
    name: "Nhat Linh",
    role: "ReallyScholar Student",
    country: "Vietnam",
    photo: "	https://fms.techtreeglobal.com/assets/uploads/1769579940_nhat.jpeg",
    message:
      "The most valuable thing I've gained from this course is the opportunity to learn a new language—a programming language. While the basic lessons were quite exciting to begin with, I encountered certain hurdles as I progressed in my self-study, and it took significantly more time than Coursera's projected schedule to complete each module."
  },
    {
    name: "Maricar Villarba",
    role: "Country Manager",
    country: "Philippines",
    photo: "https://fms.techtreeglobal.com/assets/uploads/1761491940_Maricar.jpg",
    message:
      "I learned so much through COOL. The courses are engaging, and the community support is unmatched!",
  },
  {
    name: "Bea Tumaque",
    role: "Educator and Manager",
    country: "Philippines",
    photo: "	https://fms.techtreeglobal.com/assets/uploads/1761491940_BEa.jpg",
    message:
      "Teaching on COOL has been such a rewarding experience. The community is vibrant, creative, and always ready to learn.",
  },
  {
    name: "Sean Dayap",
    role: "ReallyScholar Student",
    country: "Philippines",
    photo: "	https://fms.techtreeglobal.com/assets/uploads/1762322700_seanCOol.png",
    message:
      "I really value that I had the chance to connect with professionals in the cool session that I attended. I've observed how focused they are with their work which made me want to do the same. I really appreciate this opportunity that tech tree gave me since I've been really into improving myself and this chance to be surrounded by goal-minded people is really great!",
  },

  {
    name: "Sarah Lim",
    role: "ReallyScholar Student",
    country: "Philippines",
    photo: "	https://fms.techtreeglobal.com/assets/uploads/1762322760_Sarah.png",
    message:
      "I’m excited to continue growing and developing my skills in data analytics through the ReallyScholar program. Even though I’m only halfway through the courses, I’ve already gained valuable insights that have deepened my understanding of the field. I look forward to applying what I’ve learned to real-world data problems and turning information into meaningful outcomes.",
  },
];

const TestimonialCarousel = () => {
  const [current, setCurrent] = useState(0);

  // Auto slide every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const nextSlide = () =>
    setCurrent((prev) => (prev + 1) % testimonials.length);
  const prevSlide = () =>
    setCurrent((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );

  return (
    <section
      className="testimonial-section"
      style={{
        padding: "10px 10px",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e4ebf5 100%)",
        textAlign: "center",
        overflow: "hidden",
      }}
    >
      <h2
        style={{
          fontSize: "clamp(1.5rem, 3vw, 2rem)",
          fontWeight: "700",
          color: "#161718",
          marginBottom: "1px",
        }}
      >
         
      </h2>

          <h2
  style={{
    width: "100%",
    display: "block",
    margin: "20px auto",
        fontSize: "1.5rem",
    fontWeight: "800",
  }}
>
   What Our
  <span
    style={{
      background: "linear-gradient(90deg, #007bff, #00c6ff)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    }}
  >
    {" "}Learners Say
  </span>
</h2>

      <div
        style={{
          position: "relative",
          maxWidth: "900px",
          margin: "0 auto",
          overflow: "hidden",
        }}
      >
        {testimonials.map((t, index) => (
          <div
            key={index}
            style={{
              opacity: index === current ? 1 : 0,
              transform:
                index === current
                  ? "translateX(0)"
                  : index > current
                  ? "translateX(100%)"
                  : "translateX(-100%)",
              transition: "all 0.8s ease-in-out",
              position: index === current ? "relative" : "absolute",
              top: 0,
              left: 0,
              width: "100%",
            }}
          >
            {/* Diagonal Frame & Photo */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <div
                style={{
                  width: "160px",
                  height: "180px",
                  background:
                    "linear-gradient(135deg, #8cbff7ff, #ffffffff, #fcfefeff)",
                  padding: "6px",
                  borderRadius: "14px",
                  transform: "rotate(-3deg)",
                  boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                  transition: "transform 0.5s ease",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "10px",
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    boxShadow: "inset 0 0 10px rgba(0,0,0,0.15)",
                  }}
                >
                  <img
                    src={t.photo}
                    alt={t.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 0.8s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.1)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />
                </div>
              </div>
            </div>

            {/* Testimonial Text */}
            <blockquote
              style={{
                fontSize: "clamp(1rem, 2vw, 1.2rem)",
                color: "#333",
                fontStyle: "italic",
                lineHeight: "1.8",
                margin: "0 auto 20px",
                maxWidth: "900px",
              }}
            >
              “{t.message}”
            </blockquote>

            {/* Name, Role, Country */}
            <div style={{ marginTop: "15px" }}>
              <p
                style={{
                  fontWeight: "600",
                  color: "#007bff",
                  marginBottom: "5px",
                  fontSize: "1rem",
                }}
              >
                — {t.name}
              </p>
              <p
                style={{
                  color: "#666",
                  fontSize: "0.9rem",
                  marginBottom: "3px",
                }}
              >
                {t.role}
              </p>
              <p
                style={{
                  color: "#999",
                  fontSize: "0.85rem",
                  letterSpacing: "0.3px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.35rem",
                }}
              >
                <FlagIcon country={t.country} />
                <span>{t.country}</span>
              </p>
            </div>
          </div>
        ))}

        {/* Navigation buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            marginTop: "30px",
          }}
        >
          <button onClick={prevSlide} style={navButtonStyle}>
            ❮
          </button>
          <button onClick={nextSlide} style={navButtonStyle}>
            ❯
          </button>
        </div>
      </div>
    </section>
  );
};

// Shared button styles
const navButtonStyle = {
  background: "linear-gradient(135deg, #00eeffff, #dbd2eaff)",
  color: "#fff",
  border: "none",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  fontSize: "20px",
  cursor: "pointer",
  transition: "background 0.3s ease, transform 0.2s ease",
};

export default TestimonialCarousel;
